import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { modalSelectors, modalActions } from 'data/reducers/modal'
import { DeleteRecordModal, DELETE_RECORD_MODAL } from 'common/modals/DeleteRecordModal'
import { EditTRouteModal, EDIT_TROUTE_MODAL } from 'common/modals/EditTRouteModal'
import { ExportTRouteModal, EXPORT_TROUTE_MODAL } from 'common/modals/ExportTRouteModal'
import { ForceSaveRRModal, FORCE_SAVE_RR_MODAL } from 'common/modals/ForceSaveRRModal'
import { InsertElevationProfileModal, INSERT_ELEVATION_PROFILE_MODAL } from 'common/modals/InsertElevationProfileModal'
import { InsertImageModal, INSERT_IMAGE_MODAL } from 'common/modals/InsertImageModal'
import { PrintLoggedOutModal, PRINT_LOGGED_OUT_MODAL } from 'common/modals/PrintLoggedOutModal'
import { PrintOfficialPDFModal, PRINT_OFFICIAL_PDF_MODAL } from 'common/modals/PrintOfficialPDFModal'
import { PrintUpsellModal, PRINT_UPSELL_MODAL } from 'common/modals/PrintUpsellModal'
import { ReplaceElevationModal, REPLACE_ELEVATION_MODAL } from 'common/modals/ReplaceElevationModal'
import { SaveAsNewTRouteModal, SAVE_AS_NEW_TROUTE_MODAL } from 'common/modals/SaveAsNewTRouteModal'
import { SaveAsSegmentModal, SAVE_AS_SEGMENT_MODAL } from 'common/modals/SaveAsSegmentModal'
import { ShareModal, SHARE_MODAL } from 'common/modals/ShareModal'
import { CopyToRoutesModal, COPY_TO_ROUTES_MODAL } from 'common/modals/CopyToRoutesModal'
import { TRouteInfoModal, TROUTE_INFO_MODAL } from 'common/modals/TRouteInfoModal'
import { AccountMergeModal, ACCOUNT_MERGE_MODAL } from 'common/modals/AccountMergeModal'
import { ChangeLocaleModal, CHANGE_LOCALE_MODAL } from 'common/modals/ChangeLocaleModal'
import { QuickExportModal, QUICK_EXPORT_MODAL } from 'common/modals/QuickExportModal'
import { LoginModalOverlay, LOGIN_MODAL_OVERLAY } from 'common/styleguide/LoginModalOverlay'
import { ConfirmUpdateFollowModal, CONFIRM_UPDATE_FOLLOW_MODAL } from 'common/modals/ConfirmUpdateFollowModal'
import {
  FlagUserAsImportant, FLAG_USER_AS_IMPORTANT_DIALOG,
  TrouteDeletePhotosModal, TROUTE_DELETE_PHOTOS_MODAL
} from 'common/dialogs/AdminActionDialogs'
import { ExperienceEventEmbedModal, EXPERIENCE_EVENT_EMBED_MODAL } from 'common/modals/ExperienceEventEmbedModal'
import { CreateEditCollection, CREATE_EDIT_COLLECTION_DIALOG } from 'common/modals/CreateEditCollection'
import { SendMessage, SEND_MESSAGE_DIALOG } from 'common/dialogs/SendMessage'
import { GeneralModal, GENERAL_MODAL } from 'common/modals/GeneralModal'
import { SignupModal, SIGNUP_MODAL } from 'common/modals/SignupModal'
import { DeleteChallengeModal, DELETE_CHALLENGE_MODAL } from 'features/challenges/modals/DeleteChallengeModal'
import { CopyChallengeModal, COPY_CHALLENGE_MODAL } from 'features/challenges/modals/CopyChallengeModal'
import { CreateEditMilestoneModal, CREATE_EDIT_MILESTONE_MODAL } from 'features/challenges/modals/CreateEditMilestoneModal'
import { RequireInfoModal, REQUIRE_INFO_MODAL } from 'features/challenges/modals/RequireInfoModal'
import { LoadExistingApp, LOAD_EXISTING_MODAL } from 'features/search/LoadExisting'
import { SaveRouteApp, SAVE_ROUTE_MODAL } from 'features/recumbent/SaveRoute'
import { ModalPaymentForm, PAYMENT_FORM_MODAL } from 'features/payments/PaymentForm'
import { UpgradeModal, UPGRADE_MODAL } from 'features/recumbent/UpgradeModal'
import { CarouselModal, CAROUSEL_MODAL } from 'features/recumbent/UpgradeModal/CarouselModal'
import { AuthorEditorModal, AUTHOR_EDITOR_MODAL } from 'features/ride_reports/EditPage/AuthorEditorModal'
import { softError } from 'lib/softError'

const modalMappings = {
  [CONFIRM_UPDATE_FOLLOW_MODAL]: ConfirmUpdateFollowModal,
  [DELETE_RECORD_MODAL]: DeleteRecordModal,
  [EDIT_TROUTE_MODAL]: EditTRouteModal,
  [EXPORT_TROUTE_MODAL]: ExportTRouteModal,
  [FORCE_SAVE_RR_MODAL]: ForceSaveRRModal,
  [INSERT_ELEVATION_PROFILE_MODAL]: InsertElevationProfileModal,
  [INSERT_IMAGE_MODAL]: InsertImageModal,
  [PRINT_LOGGED_OUT_MODAL]: PrintLoggedOutModal,
  [PRINT_OFFICIAL_PDF_MODAL]: PrintOfficialPDFModal,
  [PRINT_UPSELL_MODAL]: PrintUpsellModal,
  [REPLACE_ELEVATION_MODAL]: ReplaceElevationModal,
  [SAVE_AS_NEW_TROUTE_MODAL]: SaveAsNewTRouteModal,
  [SAVE_AS_SEGMENT_MODAL]: SaveAsSegmentModal,
  [COPY_TO_ROUTES_MODAL]: CopyToRoutesModal,
  [TROUTE_INFO_MODAL]: TRouteInfoModal,
  [ACCOUNT_MERGE_MODAL]: AccountMergeModal,
  [SHARE_MODAL]: ShareModal,
  [CHANGE_LOCALE_MODAL]: ChangeLocaleModal,
  [FLAG_USER_AS_IMPORTANT_DIALOG]: FlagUserAsImportant,
  [TROUTE_DELETE_PHOTOS_MODAL]: TrouteDeletePhotosModal,
  [EXPERIENCE_EVENT_EMBED_MODAL]: ExperienceEventEmbedModal,
  [CREATE_EDIT_COLLECTION_DIALOG]: CreateEditCollection,
  [SEND_MESSAGE_DIALOG]: SendMessage,
  [UPGRADE_MODAL]: UpgradeModal,
  [GENERAL_MODAL]: GeneralModal,
  [QUICK_EXPORT_MODAL]: QuickExportModal,
  [CAROUSEL_MODAL]: CarouselModal,
  [LOAD_EXISTING_MODAL]: LoadExistingApp,
  [SAVE_ROUTE_MODAL]: SaveRouteApp,
  [PAYMENT_FORM_MODAL]: ModalPaymentForm,
  [SIGNUP_MODAL]: SignupModal,
  [DELETE_CHALLENGE_MODAL]: DeleteChallengeModal,
  [COPY_CHALLENGE_MODAL]: CopyChallengeModal,
  [CREATE_EDIT_MILESTONE_MODAL]: CreateEditMilestoneModal,
  [REQUIRE_INFO_MODAL]: RequireInfoModal,
  [LOGIN_MODAL_OVERLAY]: LoginModalOverlay,
  [AUTHOR_EDITOR_MODAL]: AuthorEditorModal
}

class _ModalLayer extends React.PureComponent {
  // dismissModal() if location.pathname changes-- otherwise modals persist
  // through spa transistions
  componentDidUpdate (prevProps) {
    const { location, dismissModal } = this.props
    if (prevProps.location && prevProps.location.pathname !== location.pathname) {
      dismissModal()
    }
  }

  render () {
    const { children, activeModal, dismissModal } = this.props
    const ModalClass = activeModal && modalMappings[activeModal.type]
    if (activeModal && !ModalClass) {
      softError(`Unknown modal type requested: ${activeModal.type}`)
    }

    return (
      <Fragment>
        {children}
        {ModalClass && <ModalClass onRequestClose={dismissModal} {...activeModal.props} />}
      </Fragment>
    )
  }
}

export const ModalLayer = connect(
  state => ({ activeModal: modalSelectors.activeModal(state) }),
  { dismissModal: modalActions.dismissModal }
)(_ModalLayer)
